import { Axis } from './Axis.js';
import { AXIS_LABEL_HEIGHT } from './constants.js';
import { OrientedAxisProps } from './types.js';

/**
 * @internal
 */
export function AxisRight({
  scale,
  label,
  width,
  ...restAxisProps
}: OrientedAxisProps) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const labelOffset = width! - AXIS_LABEL_HEIGHT;

  return (
    <Axis
      orientation="right"
      width={width}
      height={restAxisProps.containerSize}
      label={label}
      scale={scale}
      labelOffset={labelOffset}
      left={0}
      {...restAxisProps}
    />
  );
}

AxisRight['displayName'] = 'AxisRight';
